import { PaymentMethodType } from '@nemuru-eng/checkout-js';
import { getA2APaymentById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { SinglePaymentDetails } from '@/components/modules/SinglePayment/_shared/components/SinglePaymentDetails';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const A2APayment = () => {
  const { paymentMethodId } = useParams();

  if (!paymentMethodId) return null;

  const { data: a2aPaymentDetails, loading: loadingA2APayment } = useCache(getA2APaymentById, {
    id: paymentMethodId,
  });

  useSetPageLoadingWhenRequesting('A2A_PAYMENT_DETAIL', [loadingA2APayment]);

  if (!a2aPaymentDetails) return null;

  return <SinglePaymentDetails singlePayment={a2aPaymentDetails} paymentMethodType={PaymentMethodType.A2A_PAYMENT} />;
};

export const A2APaymentModule = withPermissionsModule(A2APayment);
